import { HeaderCell } from '../Interface/Hook/Interest/InterestTableDTO';

const getHighlightedColumnNumber = (highlightedColumn: string | undefined, columns: HeaderCell[]): number => {
    if (!highlightedColumn || highlightedColumn === '') return 0;

    let columnNumber = columns.findIndex(column => column.prop === highlightedColumn);

    return ++columnNumber;
};

export default getHighlightedColumnNumber;
